export default class Passo6 {
  constructor(id, lista = []) {
    this.id = id;
    this.lista = lista;
  }
}
